/* HM – szűrősáv javítás (2026-10)
 * Hiba: az eredeti facets.js a szűrőcsoportokat sorszám (data-index) alapján frissíti.
 * Ha egy szűrés után egy csoport eltűnik (pl. nincs előrendelhető termék), a sorszámok
 * elcsúsznak: a csoportok rossz helyre íródnak, a régi utolsó csoport pedig ottmarad
 * (így lett két „Ajánlott életkor”). Ez a javítás a csoportokat a szűrő paramétere
 * alapján párosítja, a megszűnteket eltávolítja, az újakat beszúrja.
 */
(function () {
  function patch() {
    if (typeof FacetFiltersForm === 'undefined' || FacetFiltersForm.__hmPatched) return;
    FacetFiltersForm.__hmPatched = true;

    var SEL = '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter';

    function key(el) {
      var form = el.closest('form');
      var field = el.querySelector('input[name^="filter."], select[name], input[name="sort_by"]');
      var name = field ? field.name.replace(/\.(gte|lte)$/, '') : 'idx:' + el.dataset.index;
      return (form ? form.id : '') + '|' + name;
    }

    FacetFiltersForm.renderFilters = function (html, event) {
      var parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      var newEls = Array.prototype.slice.call(parsedHTML.querySelectorAll(SEL));
      var curEls = Array.prototype.slice.call(document.querySelectorAll(SEL));
      var trigger = event && event.target && event.target.closest ? event.target.closest('.js-filter') : null;
      var triggerKey = trigger ? key(trigger) : null;

      var curMap = {};
      curEls.forEach(function (el) { curMap[key(el)] = el; });
      var newKeys = {};
      newEls.forEach(function (el) { newKeys[key(el)] = true; });

      // 1) A szűrés után megszűnt csoportok eltávolítása
      curEls.forEach(function (el) {
        var k = key(el);
        if (!newKeys[k] && k !== triggerKey) { el.remove(); delete curMap[k]; }
      });

      // 2) Frissítés / beszúrás a szerver által adott sorrendben
      var prevByForm = {};
      var countsSource = null;
      newEls.forEach(function (nEl) {
        var k = key(nEl);
        var formId = k.split('|')[0];
        var cur = curMap[k];
        if (cur) {
          if (k === triggerKey) {
            countsSource = nEl;
          } else {
            cur.innerHTML = nEl.innerHTML;
          }
          cur.className = nEl.className;
          cur.dataset.index = nEl.dataset.index;
        } else {
          cur = document.importNode(nEl, true);
          var prev = prevByForm[formId];
          if (prev) {
            prev.after(cur);
          } else {
            var first = document.querySelector('#' + formId + ' .js-filter');
            if (first) first.before(cur); else return;
          }
        }
        prevByForm[formId] = cur;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      if (countsSource && trigger) FacetFiltersForm.renderCounts(countsSource, trigger);
    };
  }

  // A defer-es scriptek a DOMContentLoaded előtt futnak, ezért mindig megvárjuk, hogy a facets.js is betöltődjön.
  if (document.readyState === 'complete') {
    patch();
  } else {
    document.addEventListener('DOMContentLoaded', patch);
    window.addEventListener('load', patch);
  }
})();
